<template>
    <tr>
        <td class="w-1/3 pr-xs">
            <input
                v-if="filterData.id"
                type="hidden"
                :name="`filters_data[${index}][filter_id]`"
                :value="filterData.id"
            >
            <select-input
                v-model="filterData.name"
                :name="`filters_data[${index}][name]`"
                :options="inputData.fieldOptions"
                class="mb-0"
                placeholder="Välj fält..."
                :required="true"
            />
        </td>
        <td class="w-1/3 pr-xs">
            <select-input
                v-if="filterData.name"
                v-model="filterData.operator"
                :name="`filters_data[${index}][operator]`"
                :options="getOperatorOptions(filterData.name)"
                class="mb-0"
                :required="true"
                :opt-out-sorting="true"
            />
        </td>
        <td class="w-1/3 pr-xs">
            <filter-value
                v-if="filterData.name && isOperatorRequiringValue(filterData.operator)"
                v-model="filterData.value"
                :filter-name="filterData.name"
                :input-name="`filters_data[${index}][value]`"
                :filter-properties="inputData.filtersProperties[filterData.name]"
                class="mb-0"
            />
        </td>
        <td class="w-lg text-center">
            <button type="button" @click="$emit('remove-row', index)">
                <font-awesome-icon icon="times" class="text-danger" />
            </button>
        </td>
    </tr>
</template>

<script>
    import FilterValue from './FilterValue';

    export default {
        components: {
            FilterValue,
        },

        props: {
            filterData: {
                type: Object,
                required: true,
            },
            index: {
                type: Number,
                required: true,
            },
            inputData: {
                type: Object,
                required: true,
            },
        },

        watch: {
            'filterData.name': function (newName) {
                const operatorOptions = this.getOperatorOptions(newName);
                this.filterData.operator = Object.keys(operatorOptions)[0];
            },
        },

        methods: {
            getOperatorOptions(filterName) {
                if (this.inputData.filtersProperties[filterName]
                    && this.inputData.filtersProperties[filterName].operatorOptions
                ) {
                    return this.inputData.filtersProperties[filterName].operatorOptions;
                }

                return this.inputData.defaultOperatorOptions;
            },
            isOperatorRequiringValue(operator) {
                if (! operator) {
                    return false;
                }

                return this.inputData.operatorsThatRequireValues.indexOf(operator) !== -1;
            },
        },
    };
</script>
